import { StrictMode } from "react"
import { render } from "react-dom"
import { datadogRum } from "@datadog/browser-rum"
import { LDProvider } from "launchdarkly-react-client-sdk"
import { getClientSideId } from "@shared/integration/launchdarkly"

import { App } from "./App"
import reportWebVitals from "./reportWebVitals"

// LDProvider initialises LaunchDarkly after mount, so first paint no longer waits on flag fetching.
// Flags read their defaults until LaunchDarkly is ready, then update.
render(
  <StrictMode>
    <LDProvider
      clientSideID={getClientSideId()}
      options={{
        inspectors: [
          {
            type: `flag-used`,
            name: `dd-inspector`,
            method: (key: string, detail: any) => {
              datadogRum.addFeatureFlagEvaluation(key, detail.value)
            },
          },
        ],
      }}
    >
      <App />
    </LDProvider>
  </StrictMode>,
  document.getElementById(`root`)
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log) // eslint-disable-line no-console
